module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/fb12dae6a35129a53306397ae0c3b334.gif";